import { useCallback, useEffect } from 'react';

import { FetchStatus } from '../../../enums';
import { useDispatch, useSelector } from '../../../utils';
import { fetchOrganization, resetOrganization } from '../actions';
import { selectOrganization, selectOrganizationFilters } from '../selectors';

export const useOrganization = () => useSelector(selectOrganization);
export const useOrganizationFilters = () => useSelector(selectOrganizationFilters);

export function useResetOrganization() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetOrganization());
  }, [dispatch]);
}

export function useFetchOrganization() {
  const dispatch = useDispatch();
  const organization = useOrganization();

  useEffect(() => {
    if (organization.status.organization === FetchStatus.IDLE) {
      dispatch(fetchOrganization());
    }
  }, []);
}
